export default {
  heading: "system-ui, semi-bold",
  body: "system-ui",
};
